export enum SettingsCodeEnum {
    API_URL = "api_url",
    BODY_TRACKING_TAGS = "body_tracking_tags",
    BODY_TRACKING_TAGS_PREVIEW = "body_tracking_tags_preview",
    GLOBAL_DATA_SOURCE = "global_data_source",
    HEAD_TRACKING_TAGS = "head_tracking_tags",
    HEAD_TRACKING_TAGS_PREVIEW = "head_tracking_tags_preview",
    LPL_FOOTER_DISCLOSURE_HTML = "lpl_footer_disclosure_html",
    MAIS_DISCLOSURE_HTML = "mais_disclosure_html",
    MOBILE_PAGES_WITH_LOGIN = "mobile_pages_with_login",
    MRQT_DISCLOSURE = "mrqt_disclosure",
    PAYMENT_CALCULATOR_DISCLOSURE_EN = "payment_calculator_disclosure_en",
    PAYMENT_CALCULATOR_DISCLOSURE_ES = "payment_calculator_disclosure_es",
    SITE_FOOTER_EN = "site_footer_en",
    SITE_FOOTER_ES = "site_footer_es",
    SITE_NAVIGATION_EN = "site_navigation_en",
    SITE_NAVIGATION_ES = "site_navigation_es",
    TOP_SEARCHES_EN = "top_searches_en",
    TOP_SEARCHES_ES = "top_searches_es",
    TRANSLATION_DISCLOSURE_ES = "translation_disclosure_es",
    UTILITY_NAV_EN = "utility_nav_en",
    UTILITY_NAV_ES = "utility_nav_es",
}